<template>
    <Dialog
            :open="open"
            :title="$t('zones.createZone')"
            @close="$emit('close')">
        <v-form ref="zoneForm" v-model="valid" @submit.prevent="save">
            <v-row>
                <v-col cols="12">
                    <v-text-field
                            v-model="title"
                            :rules="[$validations.required]"
                            required>
                        <template v-slot:label>
                            {{ $t('zones.name') }}<sup>*</sup>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="text-right">
                    <v-btn
                            :disabled="!valid"
                            :loading="loading"
                            class=" py-6 accentText--text shadow-inverse"
                            color="accent"
                            depressed
                            @click="save">
                        {{ $t('ok') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </Dialog>
</template>

<script>
import Dialog from "@/components/reusable/Dialog/Dialog";

export default {
  name: "ZoneNameDialog",
  components: {Dialog},
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    zoneName: {
      type: String,
      required: false,
      default: ''
    },
    circleID: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      title: this.zoneName,
      valid: false,
    };
  },
  watch: {
    zoneName(val) {
      this.title = this.zoneName;
      if (!val) {
        this.$refs.circleForm.reset();
      }
    }
  },
  methods: {
    save() {
      this.$refs.zoneForm.validate();
      if (!this.valid) {
        return;
      }
      this.$emit('save', this.title);
    }
  }
};
</script>

<style scoped>

</style>